const SVG_NS = 'http://www.w3.org/2000/svg';
const SVG_ELEMENTS = new Set([
  'svg', 'g', 'path', 'polygon', 'polyline', 'rect', 'circle',
  'ellipse', 'line', 'text', 'tspan', 'defs', 'use', 'symbol',
  'clipPath', 'mask', 'pattern', 'image', 'marker',
  'linearGradient', 'radialGradient', 'stop', 'filter',
]);

export function h(type, props, ...children) {
  // If tag is a component, call it
  if (typeof type === 'function') {
    return type({ ...props }, children);
  }
  // Create element in the correct namespace
  const element = SVG_ELEMENTS.has(type)
    ? document.createElementNS(SVG_NS, type)
    : document.createElement(type);
  // Set attributes if props are provided
  if (props) {
    Object.entries(props).forEach(([key, val]) => {
      if (key === 'className') {
        // If className attribute, add classes separately
        element.classList.add(...(val || '').trim().split(' '));
        return;
      }

      if (key.startsWith('on') && typeof val === 'function') {
        // Add event listeners
        const event = key.slice(2).toLowerCase();
        element.addEventListener(event, val);
        return;
      }

      if (key === 'style' && typeof val === 'object' && val !== null) {
        // Apply style objects (e.g. style={{ fill: '#fff' }}) directly
        Object.assign(element.style, val);
        return;
      }

      if (!(key === 'default' && val === 'false')) {
        element.setAttribute(key, val);
      }

    });
  }
  // Append child elements into the parent
  children.forEach(child => {
    if (typeof child === 'string') {
      element.appendChild(document.createTextNode(child));
    } else if (child instanceof Node) {
      element.appendChild(child);
    } else if (Array.isArray(child)) {
      child.forEach(nestedChild => element.appendChild(nestedChild));
    }
  });
  return element;
}
